module.exports = __webpack_public_path__ + "static/media/ic_hi_low.32bf76f7.svg";